import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import { getFormattedDate } from '@/utils/date';
import moment from 'moment';

const isBetween = {
  getMessage(field, args) {
    return `${field} has to be between ${args[0]} and ${args[1]}`;
  },
  validate(value, { min, max }) {
    return !(min && max) || (Number(min) <= value && Number(max) >= value);
  }
};

const isEarlier = {
  getMessage(field, args) {
    return `${args[0]} must be earlier than ${args[1]}`;
  },
  validate(value, args) {
    if (!value) return false;
    const startDate = getFormattedDate(value);
    const endDate = args[1];
    return moment(startDate).isBefore(endDate);
  }
};

const isAfter = {
  getMessage(field, args) {
    return `${args[0]} must be after than ${args[1]}`;
  },
  validate(value, args) {
    if (!value) return false;
    const endDate = getFormattedDate(value);
    const startDate = args[1];
    return moment(endDate).isAfter(startDate);
  }
};

const minTime = {
  getMessage(field, args) {
    return `${args[0]} must be after than ${args[1]}`;
  },
  validate(value, args) {
    if (!value) return false;
    const startTime = args[1] ? args[1].split(':') : args[1];
    const endTime = value ? value.split(':') : value;
    const isHoursGreater = parseInt(startTime[0], 10) > parseInt(endTime[0], 10);
    const isMinutesGreater = parseInt(startTime[1], 10) > parseInt(endTime[1], 10);
    const isHoursEqual = parseInt(startTime[0], 10) === parseInt(endTime[0], 10);
    return isHoursEqual ? !isMinutesGreater : !isHoursGreater;
  }
};

const maxTime = {
  getMessage(field, args) {
    return `${args[0]} must be before than ${args[1]}`;
  },
  validate(value, args) {
    if (!value) return false;
    const startTime = value ? value.split(':') : value;
    const endTime = args[1] ? args[1].split(':') : args[1];
    const isHoursGreater = parseInt(startTime[0], 10) > parseInt(endTime[0], 10);
    const isMinutesGreater = parseInt(startTime[1], 10) > parseInt(endTime[1], 10);
    const isHoursEqual = parseInt(startTime[0], 10) === parseInt(endTime[0], 10);
    return isHoursEqual ? !isMinutesGreater : !isHoursGreater;
  }
};


const isUnique = {
  getMessage(field, args) {
    return `${args[0]} value must be Unique`;
  },
  validate(value, args) {
    if (!value) return false;
    const [, index, ...values] = args;
    values.splice(index, 1);
    return (!values.includes(value));
  }
};


// The first param is called 'min', and the second is called 'max'.
const paramNames = ['min', 'max'];
const timeParams = ['minTime', 'maxTime'];
const uniqueParams = ['fieldName', 'values'];

Validator.extend('between', isBetween, {
  paramNames //  pass it in the extend options.
});

const dateParams = ['fieldName', 'fieldValue'];

const isPhone = {
  getMessage(field) {
    return `The ${field} must be a valid mobile number`;
  },
  validate(value) {
    // Custom regex for a phone number
    const MOBILEREG = /^([[0-9]{1,5})?([0-9][0-9]{9})$/;
    return MOBILEREG.test(value);
  }
};

Validator.extend('earlier', isEarlier, {
  dateParams
});

Validator.extend('mobile', isPhone);

Validator.extend('after', isAfter, {
  dateParams
});

Validator.extend('minTime', minTime, {
  timeParams
});

Validator.extend('maxTime', maxTime, {
  timeParams
});

Validator.extend('unique', isUnique, {
  uniqueParams
});

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
});
